import { TimeSeriesItem } from "~/modules/token_timeseries/types";

// // // //

// Helper function to get the last point value from a TimeSeriesItem
export function getLastTimeseriesValue(item: TimeSeriesItem) {
    if (item.points.length > 0) {
        const lastPoint = item.points[item.points.length - 1];
        if (lastPoint) {
            return lastPoint[1];
        }
    }
    return 0;
}

// Helper function to get the 30D ago point value from a TimeSeriesItem
export function getTimeseriesValue30DAgo(item: TimeSeriesItem) {
    if (item.points.length > 0) {
        const lastPoint = item.points[item.points.length - 1 - 30];
        if (lastPoint) {
            return lastPoint[1];
        }
    }
    return 0;
}
